import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { firstValueFrom, Subject, takeUntil, finalize } from 'rxjs';
import { GetProviderRequestParams, ProviderData } from './providers.interface';
import { Router } from '@angular/router';
import { ProvidersService } from '../../services/providers/providers.service';
import { getOffset, showNotification, toTitleCase } from 'src/app/shared/helpers/helpers';
import { ModalContent } from '../../shared/modal-content';
import { ModalComponent } from 'angular-custom-modal';
import { OptionItem } from '../../shared/types/api-responses.type';
// import { RolesService } from '../../services/roles/roles.service';

@Component({
  selector: 'app-providers',
  templateUrl: './providers.component.html',
  styleUrls: ['./providers.component.css']
})
export class ProvidersComponent implements OnInit, OnDestroy {
  @ViewChild('modal') modal!: ModalComponent;

  private destroy$ = new Subject<void>();
  loading = false;
  roles: OptionItem[] = [];

  modalData: ModalContent = new ModalContent({
    header: 'Confirmation',
    body: 'Are you sure you want to delete this provider?',
    showCloseButton: true,
    showConfirmButton: true,
    closeButtonLabel: 'Cancel',
    confirmButtonLabel: 'Delete',
    closeButtonClass: 'btn-secondary',
    confirmButtonClass: 'btn-danger',
  })

  selectedId = '';

  params = new GetProviderRequestParams();
  totalRows = 0;


  cols = [
    { field: 'no', title: 'No' },
    { field: 'code', title: 'Code' },
    { field: 'name', title: 'Name' },
    { field: 'user', title: 'User' },
    { field: 'password', title: 'Password' },
    { field: 'secret_code', title: 'Secret Code' },
    { field: 'base_url', title: 'Base URL' },
    { field: 'method', title: 'Method' },
    { field: 'inq_param', title: 'Inquiry Param' },
    { field: 'pay_param', title: 'Payment Param' },
    { field: 'adv_param', title: 'Advice Param' },
    { field: 'reversal_param', title: 'Reversal Param' },
    { field: 'inq_url', title: 'Inquiry URL' },
    { field: 'pay_url', title: 'Payment URL' },
    { field: 'adv_url', title: 'Advice URL' },
    { field: 'reversal_url', title: 'Reversal URL' },
    { field: 'callback_url', title: 'Callback URL' },
    { field: 'action', title: 'Action', type: 'action' },
  ];
  

  pageSizeOptions = [5, 10, 25, 50, 100];
  rows: ProviderData[] = [];

  constructor(
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private providerService: ProvidersService,
    // private readonly roleService: RolesService,
  ) {
  }

  ngOnInit(): void {
    this.getProviders();
    // this.getRoleData().then();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getProviders(): void {
    this.loading = true;
    this.rows = [];

    // alert(123);
    this.providerService.getProviderService(this.params)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (response) => {
          this.rows = this.processDataForTable(response.data);
          this.totalRows = response.totalPage;
        },
        error: (err) => console.error('Error fetching provider data:', err)
      });
  }

  processDataForTable(data: ProviderData[]) {
    const formattedData = data.map((each, i) => ({
      ...each,
      no: getOffset(this.params.pageNo, this.params.rowPerPage) + i + 1,
    }));
  
    console.log('Processed Data:', formattedData); // 🔍 Debug output
  
    return formattedData;
  }

  changeServer(data: any): void {
    this.params.pageNo = data.current_page;
    this.params.rowPerPage = data.pagesize;
    this.params.filter = data.search;
    this.getProviders();
  }

  onInputChanged(value: string): void {
    console.log('Debounced Input:', value);
    this.params.filter = '';
    if (value) {
      this.params.filter = value;
    }
    this.cdRef.detectChanges();
  }

  onRoleChange(roleOption: OptionItem): void {
    this.params.roleId = null;
    if (roleOption) {
      console.log('Role Change:', roleOption.value);
      this.params.roleId = roleOption.value;
    }
    this.getProviders();
  }

  goToForm(id: string): void {
    if (id === 'new') {
      this.router.navigate(['/providers/new']).then();
      return;
    }
    this.router.navigate(['/providers/edit', id]).then();
    return;
  }

  // private async getRoleData(): Promise<void> {
  //   try {
  //     const { data } = await firstValueFrom(this.roleService.getRoles());
  //     this.roles = data.map(role => ({ label: role.name, value: role.id }));
  //   } catch (error) {
  //     showNotification('error', 'Failed to fetch roles', JSON.stringify(error));
  //   }
  // }

  async deleteProvider(id: string): Promise<void> {
    this.loading = true;

    try {
      const delResp = await firstValueFrom(this.providerService.deleteProviderById(id));
      showNotification('success', 'Success to delete provider', JSON.stringify(delResp));
      this.getProviders();
    } catch (error) {
      console.error('Delete Provider Error:', error);
    } finally {
      this.loading = false;
    }
  }

  async onModalDeleteConfirm(id: string): Promise<void> {
    await this.deleteProvider(id);
    this.modal.close();
  }
}
